import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { useParams } from 'react-router-dom'
import { getIdWithPrefix } from 'utils/pathUtils'
import { NewUniversityPage } from '../new-company-pages/NewUniversityPage'

export default function University() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const universityID = urlParams?.university_name
    ? getIdWithPrefix(
        urlParams?.university_name,
        preferences?.company_type_prefix_map[ContactCompanyType.University]
      )
    : undefined

  return <NewUniversityPage universityID={universityID} />
}
